import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_OFFER_PARTNER_MUTATION = gql`
  mutation setOfferPartner($documentVersion: DocumentVersionInput!, $partnerExternalId: String!, $soldToExternalId: String!) {
    setOfferPartner(documentVersion: $documentVersion, partnerExternalId: $partnerExternalId, soldToExternalId: $soldToExternalId)
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SetOfferPartnerMutation extends Mutation<RootMutation> {
  document = SET_OFFER_PARTNER_MUTATION;
}
